import './Login.css';
import { FcGoogle } from 'react-icons/fc';
import { TiCancel } from 'react-icons/ti';
// import { FaGithub } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import useForm from './useForm';
import { loginForm } from './utility/formConfig';
import { useEffect, useState } from 'react';
import { axiosInstance } from '../../../config.util';

export default function Login(){
    const { renderFormInputs, isFormValid } = useForm(loginForm);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [serverMsg, setServerMsg] = useState({
        emilErrorMsg: '' ,
        successSignin: '',
        unIdentifiedErr: ''
    })

    useEffect(()=>{
        // let arrOfInp = [...document.getElementsByClassName('signin-input')]
        // // console.log('from input',arrOfInp);
        // for (let i = 0; i < arrOfInp.length; i++) {
        //     // console.log(arrOfInp[i].value);
        //     if(arrOfInp[i].computedName === 'email'){
        //         // console.log('got the value', arrOfInp[i].value);
        //         // console.log('got computedValue', arrOfInp[i].computedName);
        //         setEmail(arrOfInp[i].value)
        //     }
        //     else if(arrOfInp[i].computedName === 'password'){
        //         // console.log('got the value', arrOfInp[i].value);
        //         // console.log('got computedValue', arrOfInp[i].computedName);
        //         setPassword(arrOfInp[i].value)
        //     }
        // }
        // const data = document.querySelectorAll('.signup-input')
        const data = document.querySelectorAll('.signin-input')
        // console.log("data: ",data);
        data.forEach(input=>{
            // console.log(input.value);
            if(input.name === 'email')setEmail(input.value);
            if(input.name === 'password')setPassword(input.value);
        })
    })

    const formSubmit = (e)=>{
        e.preventDefault()
        // console.log('getUser function:',email, password);
        const user = {
            email: email,
            password: password,
        }
        // console.log("form submit",user);
        loginApiCall(user)
    }

    const loginApiCall = async (user)=>{
        try {
            await axiosInstance.post('/auth/login', user, {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': 'https://ndevhub.vercel.app'
                },
                // withCredentials: true
                withCredentials: 'include'
            }).then((res=>{
                // console.log('response from backend:',res.data);
                // console.log(res);
                /**
                 * res.data.refreshToken,token, username, avatar, desc, email, id
                 *  accessToken: '', email: '', id: '', refreshToken: '', user: '',
                 */  
                // setAuthState({accessToken, email, id, refreshToken, user})
                setServerMsg({
                    successSignin: 'Welcome, success signin'
                })
                // localStorage.setItem('usrdev', res.data);
                localStorage.setItem('usrdev', JSON.stringify(res.data));
                // console.log('SUCCESS...');
                window.location.reload();
            })).catch(error=>{
                if(error.response.data.hasOwnProperty('notVerified')){
                    setServerMsg({
                        unIdentifiedErr: 'You not verified yet :) check your mail'
                    })
                }else{
                    setServerMsg({
                        unIdentifiedErr: 'Invalid Crediential'
                    })
                }
            });
        } catch (error) {
            setServerMsg({
                unIdentifiedErr: 'Something Went Wrong try again working realy hard'
            })
        }
    }
    
    return(
        <div className="signin__container">
            <div className="signin__wrapper">
                <div className="signin__details-left">
                    <div className="signin_box">
                        <div className="lb-nested">
                            <div className="signin-desc">
                                <span className='whatisIt'>Productivity <br />Network</span>
                                <hr className='spacer'/>
                                <span className='wr'>We are</span>
                                <h2 className='appname'>next gen DEVHUB</h2>
                                <p className='app-desc'>Oath to build a better <span>developer</span> community.</p>
                                <p className='app-desc-para'>We invite all dev student & tech lover</p>
                                <p>
                                <a style={{fontSize: '1.3rem'}} href="https://ullaskunder.tech/" title="ullaskunder.tech"> ullaskunder.tech </a>
                                </p>
                                <h4>Lets build  & learn together</h4>
                            </div>
                            <div className="signin-linkto">
                                <span>Dont have a account? create one</span>
                                <Link to="/register">
                                    <span className='linkto-signin'>Sign up</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="signin__details-right">
                    {serverMsg.unIdentifiedErr ? <span className='si__server__message'> {serverMsg.unIdentifiedErr} </span>:null} 
                    {serverMsg.emilErrorMsg ? <span className='si__server__message'> {serverMsg.emilErrorMsg} </span>:null}
                    {serverMsg.successSignin ? <span className='si__server__message--success'> {serverMsg.successSignin} </span>:null}
                    <div className='signin__heading' style={{fontSize: "2.9rem", fontWeight: "bold"}}>Wlcome to DevHub
                    <p>
                    <p style={{fontSize: "1.5rem", fontWeight: "500", marginRight: "1rem", marginTop:'1rem', display: 'inline-block'}}>Beta tester: Create account?</p>
                        <Link to="/register">
                            <span style={{fontSize: "1.5rem", fontWeight: "500"}} className='linkto-signup'>Register</span>
                        </Link>
                    </p>
                    </div>
                    <form className="signin__main" onSubmit={formSubmit}>
                        {renderFormInputs()}
                        <Link to="/reset">
                            <div className="sigin__fogt-pass">
                                Forgot password ?
                            </div>
                        </Link>
                        <button className={`btn signin__btn-main ${!isFormValid()?'ds_btn':"alw_btn"}`} type='submit' disabled={!isFormValid()}>{!isFormValid() ? <TiCancel />:'Login'}</button>
                    </form>
                    <div className="signin-or-from">
                        <div className="title_lines">OR</div>
                    </div>
                    <div className="signin-or-from">
                        <button type="submit" className='btn signin__google'>
                            <FcGoogle className='signin-btn__icon' />
                            x- Login with Google -x
                        </button>
                    </div>
                    <p style={{position: 'absolute', bottom: '10px', fontSize: '1.5rem', right: '30px' }}>connect <a href="ullaskunder.tech" title='ullaskunder contact frontend portfolio' style={{ fontWeight: 700 }}>@ullaskunder </a></p>
                </div>
            </div>
        </div>
    )
}